import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { ProgressBar } from '../ProgressBar';

const meta: Meta<typeof ProgressBar> = {
  title: 'Components/ProgressBar',
  component: ProgressBar,
};

export default meta;
type Story = StoryObj<typeof ProgressBar>;

export const Default: Story = {
  args: {
    value: 50,
  },
};

export const StatusVariants: Story = {
  render(props) {
    return (
      <>
        <ProgressBar status="info" {...props} />
        <ProgressBar status="success" {...props} />
        <ProgressBar status="danger" {...props} />
        <ProgressBar status="warning" {...props} />
      </>
    );
  },
  args: {
    value: 50,
  },
};

export const SizeVariants: Story = {
  render(props) {
    return (
      <>
        <ProgressBar size="s" {...props} />
        <ProgressBar size="m" {...props} />
        <ProgressBar size="l" {...props} />
        <ProgressBar size="xl" {...props} />
      </>
    );
  },
  args: {
    value: 50,
  },
};
